<mat-table [dataSource]="tableDataSource" class="mat-elevation-z2">
  <ng-container matColumnDef="myName">
    <mat-header-cell *matHeaderCellDef></mat-header-cell>
    <mat-cell *matCellDef="let property">
      <div [style.font-weight]="isBoldedProp(property.propertyName) ? 'bold' : 'normal'">
        {{property.propertyName}}
      </div>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="myValue">
    <mat-header-cell *matHeaderCellDef></mat-header-cell>
    <mat-cell *matCellDef="let property">
      <div [style.font-weight]="isBoldedProp(property.propertyName) ? 'bold' : 'normal'">
        <container-element [ngSwitch]="true">
          <span *ngSwitchCase="isDateProp(property.propertyName)">{{property.propertyValue | date: 'medium'}}</span>
          <span *ngSwitchCase="isNumberProp(property.propertyName)">{{property.propertyValue | number:'1.0':'en-US' }}</span>
          <span *ngSwitchDefault>{{property.propertyValue }}</span>
        </container-element>
      </div>
    </mat-cell>
  </ng-container>
  <mat-row *matRowDef="let property; columns: columnsToDisplay"></mat-row>
</mat-table>
